import { useEffect, useState } from 'react';
import ModalOpcionesImpresion from '../../components/impresion/ModalOpcionesImpresion';
import { clienteService, pagoService, prestamoService } from '../../services/api';
import '../../styles/Pagos.css';

const Recibo = () => {
  const [pagos, setPagos] = useState([]);
  const [pagoSeleccionado, setPagoSeleccionado] = useState(null);
  const [busquedaId, setBusquedaId] = useState('');
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [clienteObj, setClienteObj] = useState(null);

  // Estados para el modal de opciones de impresión
  const [mostrarModalImpresion, setMostrarModalImpresion] = useState(false);
  const [opcionesImpresion, setOpcionesImpresion] = useState(null);
  const [whatsappData, setWhatsappData] = useState(null);

  // Estado para la configuración del sistema (logo y empresa)
  const [configuracion, setConfiguracion] = useState(null);
  const [reciboConfig, setReciboConfig] = useState(null);

  useEffect(() => {
    cargarClientes();
    cargarConfiguracion();
  }, []);

  const cargarConfiguracion = async () => {
    try {
      const response = await fetch('/api/configuracion', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      console.log('📋 Configuración cargada:', data);
      setConfiguracion(data);
      // Cargar configuración de recibos
      if (data.recibo) {
        setReciboConfig(data.recibo.amortizado || {});
        console.log('📋 Configuración de recibos:', data.recibo.amortizado);
      }
    } catch (error) {
      console.error('Error al cargar configuración:', error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.form-group')) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cargarClientes = async () => {
    try {
      const response = await clienteService.getAll({ per_page: 1000 });
      setClientes(response.data.clientes || []);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const clientesFiltrados = clientes.filter(cliente => {
    const termino = busquedaCliente.toLowerCase().trim();
    if (!termino) return true;

    return (
      (cliente.nombres && cliente.nombres.toLowerCase().includes(termino)) ||
      (cliente.apellidos && cliente.apellidos.toLowerCase().includes(termino)) ||
      (cliente.cedula && cliente.cedula.includes(termino)) ||
      (cliente.apodo && cliente.apodo.toLowerCase().includes(termino)) ||
      cliente.id.toString().includes(termino) ||
      (cliente.nombres && cliente.apellidos &&
       `${cliente.nombres} ${cliente.apellidos}`.toLowerCase().includes(termino))
    );
  }).slice(0, 10);

  const seleccionarCliente = async (cliente) => {
    setClienteObj(cliente);
    setBusquedaCliente(`${cliente.nombres} ${cliente.apellidos} - ${cliente.cedula}`);
    setMostrarDropdown(false);
    setClienteSeleccionado(cliente.id);

    // LIMPIAR ESTADOS ANTES DE CARGAR NUEVOS DATOS
    setPagos([]);
    setPagoSeleccionado(null);

    try {
      const response = await prestamoService.getAll({ cliente_id: cliente.id });
      const prestamos = response.data.prestamos || [];

      // Cargar pagos de todos los préstamos del cliente
      const todosPagos = [];
      for (const prestamo of prestamos) {
        const pagosResponse = await pagoService.getByPrestamo(prestamo.id);
        const pagosDelPrestamo = pagosResponse.data.pagos || [];

        const pagosConInfo = pagosDelPrestamo.map(pago => ({
          ...pago,
          prestamo: prestamo,
          cliente: pagosResponse.data.cliente
        }));

        todosPagos.push(...pagosConInfo);
      }

      todosPagos.sort((a, b) => new Date(b.fecha_pago) - new Date(a.fecha_pago));
      setPagos(todosPagos);
    } catch (error) {
      console.error('Error al cargar pagos:', error);
      setPagos([]); // Asegurar que se limpie en caso de error
    }
  };

  const limpiarCliente = () => {
    setClienteObj(null);
    setClienteSeleccionado('');
    setBusquedaCliente('');
    setPagos([]);
    setPagoSeleccionado(null);
  };

  const handleBuscarPorId = async () => {
    if (!busquedaId) return;

    try {
      const response = await pagoService.getById(busquedaId);

      // La respuesta puede venir en diferentes formatos
      const pago = response.data.pago || response.data;

      setPagoSeleccionado(pago);
    } catch (error) {
      console.error('Error al buscar pago:', error);
      alert('Pago no encontrado');
    }
  };

  const handleSeleccionarPago = (pago) => {
    setPagoSeleccionado(pago);
  };

  const mostrarOpcionesImpresion = () => {
    if (!pagoSeleccionado) {
      console.error('No hay pago seleccionado');
      return;
    }

    // Validar que el pago tenga un ID válido
    if (!pagoSeleccionado.id || pagoSeleccionado.id === null || pagoSeleccionado.id === undefined) {
      alert('Error: El pago seleccionado no tiene un ID válido. Por favor, selecciona un pago de la lista.');
      console.error('Pago sin ID válido:', pagoSeleccionado);
      return;
    }

    // Crear opciones de impresión para el pago seleccionado
    const opciones = {
      tipo: 'pago',
      referencia_id: pagoSeleccionado.id,
      opciones: [
        {
          id: 'imprimir',
          nombre: 'IMPRIMIR',
          icono: '🖨️',
          descripcion: 'Imprimir recibo de pago',
          endpoint: `/api/impresion/imprimir/pago/${pagoSeleccionado.id}`,
          tipo_archivo: 'html'
        },
        {
          id: 'pdf',
          nombre: 'PDF',
          icono: '📄',
          descripcion: 'Generar recibo en PDF',
          endpoint: `/api/impresion/pdf/pago/${pagoSeleccionado.id}`,
          tipo_archivo: 'pdf'
        },
        {
          id: 'whatsapp',
          nombre: 'WHATSAPP',
          icono: '💬',
          descripcion: 'Enviar por WhatsApp',
          endpoint: `/api/impresion/whatsapp/pago/${pagoSeleccionado.id}`,
          tipo_archivo: 'whatsapp'
        },
        {
          id: 'imprimir_whatsapp',
          nombre: 'IMPRIMIR Y WHATSAPP',
          icono: '🖨️💬',
          descripcion: 'Imprimir y enviar por WhatsApp',
          endpoint: `/api/impresion/combinar/pago/${pagoSeleccionado.id}`,
          tipo_archivo: 'combinar'
        }
      ]
    };

    // Crear datos de WhatsApp si hay teléfono del cliente
    let whatsappInfo = null;
    if (pagoSeleccionado.cliente && pagoSeleccionado.cliente.celular) {
      const telefono = pagoSeleccionado.cliente.celular;
      const mensaje = `✅ *RECIBO DE PAGO*\n\nHola ${pagoSeleccionado.cliente.nombres},\n\nRecibo #${pagoSeleccionado.id}\n💰 Monto: $${pagoSeleccionado.monto_total.toFixed(2)}\n📅 Fecha: ${new Date(pagoSeleccionado.fecha_pago).toLocaleDateString()}\n🏦 Préstamo: #${pagoSeleccionado.prestamo_id}\n\n¡Gracias por su pago! 🎉\n\nSistema de Préstamos KR-V`;

      whatsappInfo = {
        telefono: telefono,
        mensaje: mensaje,
        url: `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`
      };
    }

    setOpcionesImpresion(opciones);
    setWhatsappData(whatsappInfo);
    setMostrarModalImpresion(true);
  };

  const imprimirRecibo = () => {
    window.print();
  };

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString('es-DO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatearHora = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleTimeString('es-DO', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatearMoneda = (valor) => {
    return new Intl.NumberFormat('es-DO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(valor || 0);
  };

  return (
    <div className="recibo-container">
      <div className="no-print">
        <h2>Generación de Recibos</h2>

        <div className="busqueda-section">
          <div className="form-group">
            <label>Buscar por Cliente:</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por nombre, cédula, apodo o ID..."
                value={busquedaCliente}
                onChange={(e) => {
                  setBusquedaCliente(e.target.value);
                  setMostrarDropdown(true);
                }}
                onFocus={() => setMostrarDropdown(true)}
              />
              {clienteObj && (
                <button
                  type="button"
                  onClick={limpiarCliente}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    fontSize: '20px',
                    cursor: 'pointer',
                    color: '#6c757d'
                  }}
                >
                  ×
                </button>
              )}

              {mostrarDropdown && busquedaCliente && clientesFiltrados.length > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  maxHeight: '400px',
                  overflowY: 'auto',
                  zIndex: 1000,
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                }}>
                  {clientesFiltrados.map((cliente) => (
                    <div
                      key={cliente.id}
                      onClick={() => seleccionarCliente(cliente)}
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                    >
                      {cliente.foto_url ? (
                        <img
                          src={cliente.foto_url}
                          alt={cliente.nombres}
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover'
                          }}
                        />
                      ) : (
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#007bff',
                          color: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold'
                        }}>
                          {cliente.nombres?.charAt(0)}{cliente.apellidos?.charAt(0)}
                        </div>
                      )}
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 'bold' }}>
                          {cliente.nombres} {cliente.apellidos}
                          {cliente.apodo && (
                            <span style={{
                              marginLeft: '8px',
                              color: '#007bff',
                              fontStyle: 'italic',
                              fontWeight: 'normal'
                            }}>
                              ({cliente.apodo})
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: '0.9em', color: '#666' }}>
                          Cédula: {cliente.cedula} • ID: {cliente.id}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="separador">O</div>

          <div className="busqueda-id">
            <label>Buscar por ID de Pago:</label>
            <div className="input-group">
              <input
                type="text"
                value={busquedaId}
                onChange={(e) => setBusquedaId(e.target.value)}
                placeholder="ID del pago"
              />
              <button type="button" onClick={handleBuscarPorId}>Buscar</button>
            </div>
          </div>
        </div>

        {pagos.length > 0 && (
          <div className="pagos-list">
            <h3>Pagos del Cliente</h3>
            <table className="tabla-pagos">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Fecha</th>
                  <th>Préstamo</th>
                  <th>Monto</th>
                  <th>Tipo</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {pagos.map(pago => (
                  <tr key={pago.id}>
                    <td>{pago.id}</td>
                    <td>{new Date(pago.fecha_pago).toLocaleDateString()}</td>
                    <td>#{pago.prestamo_id}</td>
                    <td>${pago.monto_total.toFixed(2)}</td>
                    <td>{pago.tipo_pago}</td>
                    <td>
                      <button
                        className="btn-small"
                        onClick={() => handleSeleccionarPago(pago)}
                      >
                        Ver Recibo
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {pagoSeleccionado && (() => {
        // Determinar tipo de pago
        const montoCapital = parseFloat(pagoSeleccionado.monto_capital || 0);
        const montoInteres = parseFloat(pagoSeleccionado.monto_interes || 0);
        const montoMora = parseFloat(pagoSeleccionado.monto_mora || 0);
        const montoTotal = parseFloat(pagoSeleccionado.monto_total || 0);
        
        // Determinar etiqueta del pago según el tipo
        let etiquetaPago = "";
        let montoPago = 0;
        
        if (montoCapital > 0 && montoInteres > 0) {
          etiquetaPago = "Total Cuota Pagada";
          montoPago = montoTotal;
        } else if (montoInteres > 0 && montoCapital === 0) {
          etiquetaPago = "Total Interés Pagado";
          montoPago = montoInteres;
        } else if (montoCapital > 0 && montoInteres === 0) {
          etiquetaPago = "Total Capital Pagado";
          montoPago = montoCapital;
        } else {
          etiquetaPago = "Total Pagado";
          montoPago = montoTotal;
        }
        
        const numeroCuota = pagoSeleccionado.numero_cuota || pagoSeleccionado.prestamo?.cuotas_pagadas || 1;
        const fechaHora = `${formatearFecha(pagoSeleccionado.fecha_pago)} ${formatearHora(pagoSeleccionado.fecha_pago)}`;
        const clienteNombre = `${pagoSeleccionado.cliente?.nombres || ''} ${pagoSeleccionado.cliente?.apellidos || ''}`.trim();
        const clienteId = pagoSeleccionado.cliente?.id || pagoSeleccionado.cliente_id || 'N/A';
        
        return (
          <div className="recibo-impresion">
            <div className="recibo-header">
              {/* Logo de la empresa - Si hay logo, NO mostrar nombre */}
              {configuracion?.general?.logo ? (() => {
                const logoPath = configuracion.general.logo;
                const logoUrl = `/${logoPath}`;
                return (
                  <div style={{marginBottom: '10px', textAlign: 'center'}}>
                    <img 
                      src={logoUrl} 
                      alt="Logo empresa"
                      style={{maxWidth: '150px', maxHeight: '80px', objectFit: 'contain'}}
                      onError={(e) => {
                        console.error('❌ Error cargando logo:', e.target.src);
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                );
              })() : null}
            </div>

            <div style={{textAlign: 'center', fontWeight: 'bold', fontSize: '14px', marginBottom: '10px'}}>
              RECIBO
            </div>

            <div className="recibo-info" style={{padding: '5px'}}>
              <div style={{margin: '3px 0', fontSize: '11px'}}>{fechaHora}</div>
              <div style={{margin: '3px 0', fontSize: '11px'}}>{clienteNombre} - ID: {clienteId}</div>
              <div style={{margin: '3px 0', fontSize: '11px'}}>Préstamo: {pagoSeleccionado.prestamo_id}</div>
              <div style={{margin: '3px 0', fontSize: '11px'}}>Cuota: {numeroCuota}</div>
              <div style={{margin: '3px 0', fontSize: '11px', fontWeight: 'bold'}}>{etiquetaPago}: {formatearMoneda(montoPago)}</div>
              {montoMora > 0 && (
                <div style={{margin: '3px 0', fontSize: '11px'}}>Mora: {formatearMoneda(montoMora)}</div>
              )}
            </div>

            <div style={{textAlign: 'center', marginTop: '10px', marginBottom: '5px', fontWeight: 'bold', fontSize: '11px'}}>
              Gracias por preferirnos
            </div>

            <div className="recibo-corte" style={{
              textAlign: 'center',
              marginTop: '5px',
              paddingTop: '5px',
              borderTop: '2px dashed #000'
            }}>
            </div>

            <div className="no-print recibo-acciones">
              <button className="btn-primary" onClick={mostrarOpcionesImpresion}>
                📋 Opciones de Impresión
              </button>
              <button className="btn-secondary" onClick={() => setPagoSeleccionado(null)}>
                ✖ Cerrar
              </button>
            </div>
          </div>
        );
      })()}

      {/* Modal de opciones de impresión */}
      {mostrarModalImpresion && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999, backgroundColor: 'rgba(0,0,0,0.8)' }}>
          <ModalOpcionesImpresion
            isOpen={mostrarModalImpresion}
            onClose={() => {
              setMostrarModalImpresion(false);
              setOpcionesImpresion(null);
              setWhatsappData(null);
            }}
            opciones={opcionesImpresion?.opciones || []}
            whatsappData={whatsappData}
            titulo="Opciones de Impresión del Recibo"
            onOpcionSeleccionada={(opcion) => {
              console.log('Opción seleccionada:', opcion.nombre);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Recibo;
